import React from "react";
import FeatureList from "./FeatureList";
import PlanPrice from "./PlanPrice";

/*
    One pricing tier.

    Purely presentational: the parent owns the subscription lookup and decides
    what the button says and whether it is disabled, because that answer
    depends on Stripe state that belongs to the whole grid rather than to any
    one card.

    `theme: "dark"` comes from the catalogue, not from the card's position in
    the list. The Cruip original keys its dark treatment off a `popular` flag,
    which means moving a card in the array silently moves the styling with it.
*/
const PlanTierCard = ({ plan, buttonLabel, disabled, onSelect }) => {
  const classes = [
    "plan-tier",
    plan.theme === "dark" ? "plan-tier--dark" : "",
    // Drops the Includes list at phone widths; the flag lives on the plan so
    // the decision is visible in the catalogue rather than hidden in CSS.
    plan.hideFeaturesOnMobile ? "plan-tier--compact" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      {plan.pill && <span className="plan-tier__pill">{plan.pill}</span>}

      <div className="plan-tier__header">
        <div className="plan-tier__name">{plan.nickname}</div>
        <PlanPrice
          amount={plan.unit_amount}
          interval={plan.recurring?.interval}
        />
        <p className="plan-tier__description">{plan.subTitle}</p>

        <button
          type="button"
          className="plan-tier__cta"
          disabled={disabled}
          onClick={() => onSelect(plan)}
        >
          {buttonLabel}
        </button>
      </div>

      <div className="plan-tier__includes">Includes:</div>
      <FeatureList features={plan.features} />
    </div>
  );
};

export default PlanTierCard;
